import { Component, inject } from '@angular/core';
import { CX_ABSTRACT_SECTION_COMPONENTS } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';
import { ScreenViewModule } from '@app/core/directives/screen-view/_screen-view.module';
import { CmsComponent, CX_COMPONENT } from '@app/core/models/atomics.model';
import { CxAbstractComponent } from '@b2b/components/cms/cx-abstract/cx-abstract-component/cx-abstract.component';
import { CmsComponentPipe } from '@app/b2b/core/cms/pipes/cms-component.pipe';

@Component({
  selector: 'cx-empty-section',
  imports: [ScreenViewModule, CxAbstractComponent, CmsComponentPipe],
  templateUrl: './cx-empty-section.component.html',
})
export class CxEmptySectionComponent {
  protected components = inject<CmsComponent[]>(CX_ABSTRACT_SECTION_COMPONENTS);

  CX_COMPONENT = CX_COMPONENT;
}
